module.exports = __webpack_public_path__ + "static/media/porch-delivery.ac20b1f5.png";